import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { AuthProvider } from './contexts/AuthContext';
import { TagProvider } from './contexts/TagContext';
import client from './apollo/client';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import OAuthCallback from './pages/OAuthCallback';
import Profile from './pages/Profile';
import Tests from './pages/Tests';
import TestPage from './pages/TestPage';
import Voting from './pages/Voting';
import VotingDemoPage from './pages/VotingDemo';
import VotingDetail from './pages/VotingDetail';
import CreateVoting from './pages/CreateVoting';
import MyVoting from './pages/MyVoting';
import FavoriteVoting from './pages/FavoriteVoting';
import Matching from './pages/Matching';
import UserDetail from './pages/UserDetail';
import Friends from './pages/Friends';
import Chat from './pages/Chat';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';

function App() {
  return (
    <ApolloProvider client={client}>
      <AuthProvider>
        <TagProvider>
          <Router>
            <Layout>
              <Routes>
              <Route path="/" element={<Home />} />
              <Route 
                path="/login" 
                element={
                  <PublicRoute>
                    <Login />
                  </PublicRoute>
                } 
              />
              <Route 
                path="/register" 
                element={
                  <PublicRoute>
                    <Register />
                  </PublicRoute>
                } 
              />
              <Route 
                path="/oauth/callback" 
                element={<OAuthCallback />} 
              />
              <Route 
                path="/oauth/error" 
                element={<OAuthCallback />} 
              />
              <Route 
                path="/profile" 
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/questions" 
                element={<Navigate to="/voting" replace />}
              />
              <Route 
                path="/tests" 
                element={
                  <ProtectedRoute>
                    <Tests />
                  </ProtectedRoute>
                } 
              />
              <Route path="/test/:testId" element={<TestPage />} />
              <Route path="/voting" element={<Voting />} />
              <Route path="/voting-demo" element={<VotingDemoPage />} />
              <Route path="/voting/:id" element={<VotingDetail />} />
              <Route 
                path="/voting/create" 
                element={
                  <ProtectedRoute>
                    <CreateVoting />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/voting/my" 
                element={
                  <ProtectedRoute>
                    <MyVoting />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/voting/favorites" 
                element={
                  <ProtectedRoute>
                    <FavoriteVoting />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/matching" 
                element={
                  <ProtectedRoute>
                    <Matching />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/user/:userId" 
                element={
                  <ProtectedRoute>
                    <UserDetail />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/friends" 
                element={
                  <ProtectedRoute>
                    <Friends />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/chat/:userId" 
                element={
                  <ProtectedRoute>
                    <Chat />
                  </ProtectedRoute>
                } 
              />

              {/* 管理員路由 */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />

              <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </Router>
        </TagProvider>
      </AuthProvider>
    </ApolloProvider>
  );
}

export default App;
